import React from 'react'
import { Descriptions } from "antd"
import PropTypes from "prop-types"

import useItems from "./helpers/useItems"
import { AccountShape } from "../../shapes"


const AccountDescriptions = ({ account, onAfterUpdated }) => {
  const items = useItems(account, onAfterUpdated)

  return (
    <Descriptions
      bordered
      size="small"
      column={1}
      className="compact black"
      labelStyle={{ width: "40%" }}
    >
      {
        items.map(({ label, value }, key) => (
          <Descriptions.Item
            key={key}
            label={label}
          >
            {value}
          </Descriptions.Item>
        ))
      }
    </Descriptions>
  )
}

AccountDescriptions.propTypes = {
  account: AccountShape.isRequired,
  onAfterUpdated: PropTypes.func.isRequired,
}

export default AccountDescriptions
